import { createLookupTable } from '../utils';

const statuses = {
  active: 'success',
  cancelled: 'warning',
  needs_review: 'info',
  active_pending: 'info',
  cancelled_pending: 'warning',
  not_current_version: 'warning',
} as const;

export type InsuranceLabel = keyof typeof insuranceTable;
export const insuranceTable = createLookupTable(statuses, 'insurance');
